@if (employeeDataLoading$ | async) {
  <app-loading-screen
    [local]="true"
    [contrast]="true"></app-loading-screen>
} @else {
  @if (!(employeeProfile$ | async) && employeeProfileLoadingError$ | async; as loadingError) {
    <div class="error-container">
      @if (loadingError === loadingErrorType.NotFound) {
        <div class="error-message">
          <mat-icon>error</mat-icon>
          <p>{{ 'org-management.employee-not-found-error' | translate }}</p>
        </div>
      }
      @if (loadingError === loadingErrorType.Other) {
        <div class="error-message">
          <mat-icon>error</mat-icon>
          <p>{{ 'org-management.employee-loading-error' | translate }}</p>
        </div>
        <coin-v2-button
          icon="refresh"
          type="outline"
          [text]="'org-management.reload' | translate"
          (click)="reload()"></coin-v2-button>
      }
    </div>
  }

  <coin-org-tree-employee-profile
    showPreferredName="preferredAndFull"
    [employeeProfile]="employeeProfile$ | async"
    [showManagement]="showManagement$ | async"
    [additionalPositions]="additionalPositions$ | async"
    [currentPosition]="currentPosition$ | async"
    [currentOrganisation]="currentOrganisation$ | async"
    (closeProfile)="close.emit()"
    (goToLegalEntity)="router.navigate(['/legal-entities'], { queryParams: $event })"
    (goToOrgCode)="router.navigate(['/org-management'], { queryParams: $event })"></coin-org-tree-employee-profile>
}
